<div id="locate-agree-container">
  <div>
    <h5 mat-dialog-title>VERIFY LOCATION</h5>
  </div>
  <div>
    <p class="center-text"><b>When you are in front of the home, please allow Tricon to use your location. Tricon will verify your location and then allow you access to self tour the home. This will only work within 100 feet of the home.</b></p>
    <p class="center-text">Tricon will use your location to verify your identity and location in order to allow you to access Self Tour.</p>
  </div>
  <div>
    <div class="flex justify-end">
      <div class="w-full sm:w-1/3">
        <div class="grid grid-cols-1">
          <button mat-flat-button color="accent" (click)="locateAgree()">ALLOW</button>
        </div>
      </div>
    </div>
  </div>
  <p>*Note: To be able to use the self tour process, a smart phone with GPS capabilities is required. Location services must be turned on in your smart phone settings.</p>
</div>
